export default __webpack_public_path__ + "static/media/ic_recycle.7a6327d2.svg";